import { render, staticRenderFns } from "./QuestionInputTextBox.vue?vue&type=template&id=2d6a7358&"
import script from "./QuestionInputTextBox.vue?vue&type=script&lang=ts&"
export * from "./QuestionInputTextBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports